import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { getAssociadoLocalStorageAccessToken } from 'utils/AssociadoAuthUtils';
import { getWSO2LocalStorageAccessToken } from 'utils/WSO2AuthUtils';
import { getAssembleiasNotificacaoEndpoint } from 'library/Apis';
import { AssociadoAuthLocalStorageNames } from 'enuns/AssociadoAuthLocalStorageNames';

const ApiService: AxiosInstance = axios.create({
  headers: {
    'Accept-Language': 'pt, pt-BR',
  }
});

const getToken = (): string | null => {
  return getWSO2LocalStorageAccessToken() || getAssociadoLocalStorageAccessToken();
}

ApiService.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // Interceptor de autenticação
    const token = getToken();
    if (token && config.url && config.url.indexOf(getAssembleiasNotificacaoEndpoint()) === -1) {
      config.headers = {
        ...config.headers,
        Authorization: token,
      }
    }
    return config;
  }
);

const clearTokenAndRedirect = () => {
  window.localStorage.removeItem(AssociadoAuthLocalStorageNames.AccessToken);
  window.location.href = '/assembleiadefundos';
};

ApiService.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      clearTokenAndRedirect();
    }
    return Promise.reject(error);
  }
);

export default ApiService;